import { FC } from 'react';
import { Badge } from '@components/atoms/Badge';
import { useTranslation } from '@hooks/useTranslation';
import { DailySiteReportEmailStatus } from '@models/dailySiteReport.model';

const VARIANT: Record<DailySiteReportEmailStatus, 'default' | 'success' | 'error' | 'warning'> = {
  [DailySiteReportEmailStatus.PENDING]: 'warning',
  [DailySiteReportEmailStatus.SENT]: 'success',
  [DailySiteReportEmailStatus.FAILED]: 'error',
  [DailySiteReportEmailStatus.SKIPPED_EMPTY]: 'default',
  [DailySiteReportEmailStatus.SKIPPED_OPTED_OUT]: 'default',
};

export const EmailStatusChip: FC<{ status: DailySiteReportEmailStatus }> = ({ status }) => {
  const t = useTranslation('dailySiteReport');
  const LABEL: Record<DailySiteReportEmailStatus, string> = {
    [DailySiteReportEmailStatus.PENDING]: t.statusPending,
    [DailySiteReportEmailStatus.SENT]: t.statusSent,
    [DailySiteReportEmailStatus.FAILED]: t.statusFailed,
    [DailySiteReportEmailStatus.SKIPPED_EMPTY]: t.statusSkippedEmpty,
    [DailySiteReportEmailStatus.SKIPPED_OPTED_OUT]: t.statusSkippedOptedOut,
  };
  return (
    <Badge size="sm" variant={VARIANT[status]}>
      {LABEL[status]}
    </Badge>
  );
};

export default EmailStatusChip;
